import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b8a27cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "workout-segments" }

import { toRefs } from 'vue'

  import { IWorkoutSegment } from '@/types/workouts'

  interface Props {
    segments: IWorkoutSegment[]
    useImperialUnits: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    segments: null,
    useImperialUnits: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    segments: IWorkoutSegment[]
    useImperialUnits: boolean
  }

  

  const { segments, useImperialUnits } = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Distance = _resolveComponent("Distance")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('workouts.SEGMENT', 2)), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(segments), (segment, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: segment.segment_id
            }, [
              _createVNode(_component_router_link, {
                to: {
                name: 'WorkoutSegment',
                params: {
                  workoutId: segment.workout_id,
                  segmentId: index + 1,
                },
              }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('workouts.SEGMENT', 1)) + " " + _toDisplayString(index + 1), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createTextVNode(" (" + _toDisplayString(_ctx.$t('workouts.DISTANCE')) + ": ", 1),
              _createVNode(_component_Distance, {
                distance: segment.distance,
                unitFrom: "km",
                useImperialUnits: _unref(useImperialUnits)
              }, null, 8, ["distance", "useImperialUnits"]),
              _createTextVNode(", " + _toDisplayString(_ctx.$t('workouts.DURATION')) + ": " + _toDisplayString(segment.duration) + ") ", 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})